import { AxiosResponse } from 'axios';
import { investmentEntityRequest } from '@utils/request';
import { NotificationResponse } from 'types/header';

export const getNotifications = async (): Promise<NotificationResponse> => {
	const response: AxiosResponse<NotificationResponse> = await investmentEntityRequest.get('/notifications');
	return response.data;
};

export const updateNotifications = async (timestamp: object): Promise<void> => {
	await investmentEntityRequest.post(`/notifications`, timestamp);
};
